import { FaCheck } from "react-icons/fa";
import { FaXmark } from "react-icons/fa6";

export default class CommonUtils  {

    odooCountryList = [
        {id: "12", name: "Österreich"},
        {id: "57", name: "Deutschland"}
    ];

    odooStateATList = [
        {id: "1436", name: "Burgenland"},
        {id: "1437", name: "Kärnten"},
        {id: "1438", name: "Niederösterreich"},
        {id: "1439", name: "Oberösterreich"},
        {id: "1440", name: "Salzburg"},
        {id: "1441", name: "Steiermark"},
        {id: "1442", name: "Tirol"},
        {id: "1443", name: "Vorarlberg"},
        {id: "1444", name: "Wien"},
    ]

    compareDate = (date1, operator, date2) => {
        // change date to full dates
        const d1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
        const d2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());

        // compare
        if (operator === ">") {
            if (d1.getTime() > d2.getTime()) return true;
            else return false;
        }
        if (operator === ">=") {
            if (d1.getTime() >= d2.getTime()) return true;
            else return false;
        }
        if (operator === "<") {
            if (d1.getTime() < d2.getTime()) return true;
            else return false;
        }
        if (operator === "<=") {
            if (d1.getTime() <= d2.getTime()) return true;
            else return false;
        }
        if (operator === "=" || operator === "==" || operator === "===") {
            if (d1.getTime() === d2.getTime()) return true;
            else return false;
        }
    }

    country_id_toStringName = (country_id) => {
        var str_country_id = "";
        switch (country_id) {
            case "12":
                str_country_id = "Österreich";
                break;
            case "57":
                str_country_id = "Deutschland";
                break;
            default:
                str_country_id = "";
                break;
        }
        return str_country_id;
    }

    state_id_toStringName = (state_id) => {
        var str_state_id = "";
        switch (state_id) {
            case "1436":
                str_state_id = "Burgenland";
                break;
            case "1437":
                str_state_id = "Kärnten";
                break;
            case "1438":
                str_state_id = "Niederösterreich";
                break;
            case "1439":
                str_state_id = "Oberösterreich";
                break;
            case "1440":
                str_state_id = "Salzburg";
                break;
            case "1441":
                str_state_id = "Steiermark";
                break;
            case "1442":
                str_state_id = "Tirol";
                break;
            case "1443":
                str_state_id = "Vorarlberg";
                break;
            case "1444":
                str_state_id = "Wien";
                break;
            default:
                str_state_id = "";
                break;
        }
        return str_state_id;
    }


    dateToEuFormat = (date) => {
        try {
            const convertedDate = new Date(date).toLocaleDateString("de-DE", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
            });
            if (convertedDate === "Invalid Date") return this.checkUncheckIcons(false);
            return convertedDate;
        
        } catch {
            return "";
        }
    }

    checkUncheckIcons = (target) => {
        if (target) {
            return <FaCheck className="text-energo" />
        } else {
            return <FaXmark className="text-danger" />
        }
    }

    ibanHandler = (newVal) => {
        const formatedValue = newVal.replace(/[^a-zA-Z0-9]/g, '');
        const formated4Group = formatedValue.substring(0).replace(/(.{4})(?!$)/g, "$1 ").toUpperCase();
        return formated4Group;
    }
}